import React from 'react'
import BybTermsCondition from './BybTermsCondition/BybTermsCondition'
import PageSeo from '../Common/Seo/PageSeo'

const TermsConditionPage = () => {
  return (
    <div>
        <PageSeo
          title="Terms and Conditions | Brew Your Brand"
          description="Review the Brew Your Brand terms and conditions for access to our branding resources, services, community, and digital products."
          canonical="/terms-and-conditions"
          ogTitle="Terms and Conditions | Brew Your Brand"
        />
        <BybTermsCondition />
        </div>
  )
}

export default TermsConditionPage
